import { render, staticRenderFns } from "./UserManagersCard.vue?vue&type=template&id=74c83772&scoped=true"
import script from "./UserManagersCard.vue?vue&type=script&lang=js"
export * from "./UserManagersCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c83772",
  null
  
)

export default component.exports